import '@assets/themes/index.scss';

export const loadTheme = async () => {
  const redirected = localStorage.getItem('redirected_from_partner');
  if (!redirected) return;

  try {
    await import(`@assets/themes/organizations/${redirected}.scss`);
    console.log(`Partner theme loaded: ${redirected}`);
  } catch (e) {
    console.warn('Theme load failed, fallback to build theme', e);
  }
};
